// @flow

/**
 * Module dependencies.
 */

import { Col, Container, Row } from 'client/components/core/grid';
import { Separator, separatorSizes } from 'client/components/separator';
import { colors, media, units } from 'client/styles';
import { position } from 'polished';
import Icon from 'client/components/core/icon';
import Layout from 'client/components/core/layout';
import React from 'react';
import Text from 'client/components/core/type';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  features: Array<Object>
};

/**
 * Styles.
 */

const styles = {
  separator: `
    top: -${7 * 8 + separatorSizes.large / 2}px;
  `
};

/**
 * Separator `Col` wrapper.
 */

const ColSeparator = styled(Col)`
  ${position('absolute', '0', null, null, '0')}

  ${media.max.md`
    display: none;
  `}
`;

/**
 * Export `Features`.
 */

function Features({ features }: Props): React$Element<*> {
  const renderFeaturesContent = (): any => features.map((item: Object, index: number): React$Element<*> => (
    <Col
      key={index}
      md={2}
      mdOffset={1}
      sm={4}
      smOffset={0}
      xs={10}
      xsOffset={1}
    >
      <Layout
        paddingBottom={units(6)}
        paddingBottomSm={units(0)}
      >
        <Icon
          icon={item.icon}
          size={'200px'}
        />

        <Text.H4 color={colors.brandPrimary}>
          {item.title}
        </Text.H4>

        <Layout
          paddingHorizontalMd={0}
          paddingHorizontalSm={units(4)}
        >
          <Text.Paragraph>
            {item.description}
          </Text.Paragraph>
        </Layout>
      </Layout>
    </Col>
  ));

  return (
    <Layout
      backgroundColor={colors.white}
      textAlign={'center'}
    >
      <Layout paddingVertical={units(7)}>
        <Container>
          <Row>
            <Layout position={'relative'}>
              <ColSeparator
                xs={1}
                xsOffset={1}
              >
                <Separator.Vertical
                  absolute
                  styles={styles.separator}
                />
              </ColSeparator>

              <Col
                md={1}
                xs={12}
              />

              {renderFeaturesContent()}
            </Layout>
          </Row>
        </Container>
      </Layout>
    </Layout>
  );
}

export default Features;



// WEBPACK FOOTER //
// ../src/client/components/home/features.js